import styled from 'styled-components'

import { RewardsHeading2 } from '../../../RewardsHeading'

export const Heading2 = styled(RewardsHeading2)`
  margin-right: 16px;
  margin-bottom: 4px;
`

export const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
`

export const HeaderParagraph = styled.h4`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.global.body};
  font-weight: 400;
  color: rgba(20, 70, 131, 0.8);
  margin-bottom: 0;
`

export const ClassificationsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  flex-wrap: wrap;

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  & > :nth-child(1) {
    background-color: ${({ theme }) => theme.colors.blackPearlBlue.shade600};
    border: none;

    h1,
    label {
      color: ${({ theme }) => theme.colors.brand.white};
    }

    svg {
      color: ${({ theme }) => theme.colors.brand.white};
    }
  }
`
